var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[(_vm.user.confirm_token)?_c('div',[_c('form',{staticClass:"form",attrs:{"method":"post"}})]):_c('div',[_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t("auth.tokenAlert")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }